import React from 'react';
import PageBase from '../PageBase/PageBase';
import '../../styles/insightCards.css';

export default function Home(): React.ReactElement {
  return (
    <PageBase
      pageType="home"
      resourceId={null}
      leftPanelTitle="Welcome to Fisheries OS"
      rightPanelTitle="US Fisheries Performance"
      topPanelModules={null}
      bottomPanelVisible={true}
    />
  );
}
